export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12409.b741b742.jpg";